import { InfoCircleTwoTone } from "@ant-design/icons";
import { Box, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";
import { useOpenUrl } from "@src/mobile/utils/openUrl";

interface PlacementReviewBannerProps {
  candidateCount: number;
}

export function PlacementReviewBanner({ candidateCount }: PlacementReviewBannerProps) {
  const theme = useTheme();
  const openUrl = useOpenUrl();

  return (
    <Box
      sx={(theme) => ({
        backgroundColor: alpha(theme.palette.error.main, 0.1),
        paddingX: theme.spacing(2),
        paddingY: theme.spacing(1),
        border: `1px solid ${alpha(theme.palette.error.main, 0.3)}`,
        borderRadius: theme.borderRadius?.large,
        width: "fit-content",
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(2),
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
      })}
    >
      <InfoCircleTwoTone twoToneColor={theme.palette.error.main} />
      <Text
        variant="body2"
        sx={{
          color: theme.palette.error.main,
          paddingX: theme.spacing(1),
        }}
      >
        <Text inline bold variant="body2" sx={{ color: "inherit" }}>
          {candidateCount}
        </Text>{" "}
        Candidates are awaiting your review. Please review them now and choose to request an
        interview or decline.
      </Text>
      <Button
        variant="danger"
        size="small"
        onClick={() => {
          void openUrl("/workplace/manage-jobs?tab=applicants");
        }}
      >
        View candidates
      </Button>
    </Box>
  );
}
